module.exports = __webpack_public_path__ + "static/img/quxiaoquantijingyin2.13da3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/quxiaoquantijingyin2.png
// module id = /tn7
// module chunks = 24